// Small stroke icons for the console (16px grid, currentColor)
const Icon = ({ children, className = "h-4 w-4" }) => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    {children}
  </svg>
);

export const BuildingIcon = (p) => (
  <Icon {...p}><path d="M2.5 14.5v-11l6-2v13M8.5 5.5l5 1.5v7.5M1 14.5h14M4.5 5.5h1.5M4.5 8h1.5M4.5 10.5h1.5M10.5 8.5h1M10.5 11h1" /></Icon>
);
export const ActivityIcon = (p) => (
  <Icon {...p}><path d="M1.5 8h3l2-5 3 10 2-5h3" /></Icon>
);
export const ClockIcon = (p) => (
  <Icon {...p}><circle cx="8" cy="8" r="6.5" /><path d="M8 4.5V8l2.5 1.5" /></Icon>
);
export const UsersIcon = (p) => (
  <Icon {...p}><circle cx="6" cy="5" r="2.5" /><path d="M1.5 14c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5M11 2.8a2.5 2.5 0 010 4.4M12.5 9.8c1.2.6 2 1.9 2 4.2" /></Icon>
);
export const ShieldIcon = (p) => (
  <Icon {...p}><path d="M8 1.5l5.5 2v4c0 3.5-2.3 6-5.5 7-3.2-1-5.5-3.5-5.5-7v-4z" /><path d="M5.5 8l1.8 1.8L10.5 6.5" /></Icon>
);
export const PauseIcon = (p) => (
  <Icon {...p}><circle cx="8" cy="8" r="6.5" /><path d="M6.5 5.5v5M9.5 5.5v5" /></Icon>
);
export const AlertIcon = (p) => (
  <Icon {...p}><path d="M8 1.8l6.5 11.4H1.5z" /><path d="M8 6.2v3M8 11.3v.2" /></Icon>
);
export const LogoutIcon = (p) => (
  <Icon {...p}><path d="M6 2.5H3v11h3M10.5 11L13.5 8l-3-3M13.5 8H6" /></Icon>
);
export const ArrowLeftIcon = (p) => (
  <Icon {...p}><path d="M13 8H3M7 4L3 8l4 4" /></Icon>
);
export const ArrowRightIcon = (p) => (
  <Icon {...p}><path d="M3 8h10M9 4l4 4-4 4" /></Icon>
);
export const SearchIcon = (p) => (
  <Icon {...p}><circle cx="7" cy="7" r="4.5" /><path d="M10.5 10.5L14 14" /></Icon>
);
export const ExternalIcon = (p) => (
  <Icon {...p}><path d="M9.5 2.5h4v4M13.5 2.5L7.5 8.5M11.5 9.5v4h-9v-9h4" /></Icon>
);
export const MailIcon = (p) => (
  <Icon {...p}><rect x="1.5" y="3" width="13" height="10" rx="1.5" /><path d="M2 4l6 5 6-5" /></Icon>
);
